module.exports = __webpack_public_path__ + "p3_img2.jpg?bbae3a8f6e5fb40cc07ec3816902562f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p3/p3_img2.jpg
// module id = 53
// module chunks = 0